import { createBrowserHistory } from "history";
import React from "react";
import { Route, Router, Switch } from "react-router-dom";
import AmazeTest from "../pages/afterLogin/amazeTest/amazeTest";
import MAPPR from "../pages/afterLogin/mappr/mappr";
import Profile from "../pages/afterLogin/profile/profile";
import StartTest from "../pages/afterLogin/startTest/startTest";
import Survey from "../pages/afterLogin/survey/survey";
import Calibration from "../pages/afterLogin/calibration/calibration";
import CalibrationTest from "../pages/afterLogin/calibrationTest/calibrationTest";
import SurveyQues from "../pages/afterLogin/survey/surveyQues";
import Login from "../pages/beforeLogin/login/login";
import SignUp from "../pages/beforeLogin/signUp/signUp";
import ErrorPage from "../pages/errorPage";
import { HelperProvider } from "../store/helperStore";
import { LoginProvider } from "../store/loginStore";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";
import MAPPRTracker from "../pages/afterLogin/mapprTracker/mapprTracker";
const history = createBrowserHistory();

export default function ProjectRouter() {
  return (
    <LoginProvider>
      <HelperProvider>
        <Router history={history}>
          <Switch>

            <PublicRoute path="/" component={Login} exact={true} />

            <PublicRoute path="/signup" component={SignUp} exact={true} />

            <PrivateRoute path="/mappr" component={MAPPR} exact={true} />

            <PrivateRoute path="/startTest" component={StartTest} exact={true}
            />

            <PrivateRoute
              path="/amaze_test"
              component={AmazeTest}
              exact={true}
              />

            <PrivateRoute path="/survey" component={Survey} exact={true} />

            <PrivateRoute
              path="/survey/:id"
              component={SurveyQues}
              exact={true}
            />

            <PrivateRoute
              path="/calibration"
              component={Calibration}
              exact={true}
            />

            <PrivateRoute
              path="/calibration/test"
              component={CalibrationTest}
              exact={true}
            />

            <PrivateRoute path="/profile" component={Profile} exact={true} />
            <PrivateRoute path="/mappr_tracker" component={MAPPRTracker} exact={true}/>
            <Route component={ErrorPage} />
          
          </Switch>
        </Router>
      </HelperProvider>
    </LoginProvider>
  );
}
